import {Component, OnInit, HostListener} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {CatalogoApiService} from '../../../service/api/catalogo.api';
import {Router, ActivatedRoute} from '@angular/router';
import {Servico} from '../../../model/catalogo';
import {Subscription} from 'rxjs/Subscription';
import {DetalhamentoApiService} from '../../../service/api/detalhamento.api';

@Component({
    selector: 'cadastro-servico',
    templateUrl: './cadastro-servico.component.html',
    styleUrls: ['./cadastro-servico.component.css']
})
export class CadastroServicoComponent {

    modoEdicao: Boolean = false;
    paramsSubscription: Subscription = null;

    nome = new FormControl('', []);
    descricao = new FormControl('', []);
    tipoEdicao = new FormControl('0', []);
    codigo: number = null;
    versao: number = null;
    titulo: string;

    servicoForm: FormGroup = this.formBuilder.group({
        nome: this.nome,
        descricao: this.descricao,
    });

    novoServico: Servico = new Servico();

    constructor(private globalService: GlobalService, private router: Router, private route: ActivatedRoute, public modalService: ModalService, private formBuilder: FormBuilder, private catalogoService: CatalogoApiService, public detalhamentoApiService: DetalhamentoApiService) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13 && this.servicoForm.valid) {
                this.salvarServico();
            } else {
            }
        }
    }


    ngOnInit() {
        this.paramsSubscription = this.route.params.subscribe(params => {
            if (params['codigo'] != undefined) {
                this.modoEdicao = true;
                this.novoServico.codigo = params['codigo'];
                this.novoServico.versao = params['versao'];
                this.getDadosServico(params['codigo'], params['versao']);
                this.titulo = 'Editar Serviço';
            } else {
                this.titulo = 'Novo Serviço';
            }
        });
    }

    ngOnDestroy() {
        if (this.paramsSubscription != null) {
            this.paramsSubscription.unsubscribe();
        }
    }

    getDadosServico(codigo: number, versao: number) {
        this.detalhamentoApiService.detalhaServico(codigo, versao)
            .subscribe(response => {
                    this.nome.setValue(response.nome.trim());
                    this.descricao.setValue(response.descricao.trim());
                    this.codigo = response.codigo;
                    this.versao = response.versao;
                },
                erro => {
                });
    }

    salvarServico() {
        if (this.modoEdicao) {
            var msgLayoutArquivo: string = 'Por padrão, a alteração é gravada nesta mesma versão de serviço. Se optar por gravar em uma nova versão, os FTAs que atualmente apontam para esta instalação vão manter uso dos parâmetros e definições da versão antiga. Deseja manter a mesma versão vigente ?';
            this.modalService.abrirPaginaModal('edicao-artefatos-modal', {}, {
                    'pesquisar': false,
                    'mensagem': msgLayoutArquivo
                },
                'Confirmação !', 'Fechar')
                .subscribe(resp => {
                    if (resp.tipoEdicao) {
                        this.novoServico.codigo = this.codigo;
                        this.novoServico.versao = this.versao;
                    } else {
                        this.novoServico.codigo = 0;
                        this.novoServico.versao = 0;
                    }
                    this.criaEditaServico();
                });
        } else {
            this.novoServico.codigo = 0;
            this.novoServico.versao = 0;
            this.criaEditaServico();
        }

        this.novoServico.nome = this.servicoForm.value.nome;
        this.novoServico.descricao = this.servicoForm.value.descricao;
    }

    criaEditaServico() {
        //this.modalService.fecharPaginaModal();
        this.catalogoService.criaEditaServico(this.novoServico.codigo, this.novoServico.versao, this.novoServico)
            .subscribe(
                resposta => {
                    if (this.modoEdicao) {
                        this.modalService.exibirMensagem('Serviço', 'Serviço atualizado com sucesso!', 'Fechar');
                    } else {
                        this.modalService.exibirMensagem('Serviço', 'Serviço cadastrado com sucesso!', 'Fechar');
                    }
                    this.voltar();
                },
                erro => {
                    if (erro.status == 400) {
                        this.modalService.exibirMensagem('Serviço', 'Erro ao cadastrar serviço.<br />Verifique se os campos foram preenchidos corretamente.', 'Fechar');
                    } else if (erro.status == 401) {
                        this.modalService.exibirMensagem('Serviço', 'Erro ao cadastrar serviço.<br />Token de autenticação fora do formato esperado, inválido ou expirado.', 'Fechar');
                    } else if (erro.status == 403) {
                        this.modalService.exibirMensagem('Serviço', 'Erro ao cadastrar serviço.<br />Usuário não possui permissão para efetuar essa operação.', 'Fechar');
                    } else if (erro.status == 409) {
                        this.modalService.exibirMensagem('Serviço', 'Erro ao cadastrar serviço.<br />Código/Versão incorretos.', 'Fechar');
                    } else {
                        this.modalService.exibirMensagem('Serviço', 'Erro ao cadastrar serviço.<br />Erro interno do servidor.', 'Fechar');
                    }

                }
            );
    }

    voltar() {
        this.router.navigate(['/artefato-servico']);
    }

}



// WEBPACK FOOTER //
// ./src/app/artefato/cadastro-servico/cadastro-servico.component.ts